function init() {
	$(".btn-download-magazine").unbind("click");
	$(".btn-download-magazine").bind("click",function(e) {
		var form = $(this).closest("form");
		var alert = form.find(".alert:first");
		alert.html("");
		alert.addClass("hide");
		
		var formContent = $(this).parent().find(".form-content-magazine:first");
		
		if(!formContent.is(':visible')){
			formContent.fadeIn();
		}else{
			$.ajax({
			   type: "POST",
			   url: form.attr("action"),
			   data: form.serialize(), 
			   success: function(data)
			   {
				   if(!data.success){
					    for(var i = 0; i < data.errors.length; i++){
						   alert.append("<p>&#x2022; " + data.errors[i] + "</p>")
					    }
					   
					    alert.removeClass("hide");
				   }else{
						alert.addClass("hide");
						window.location.href = data.data;
				   }
			   }
			 });
		}
		
		e.preventDefault();
	}); 
	
	$(".magazine-form input[type='text'], .magazine-form input[type='email']").unbind("keyup");
	$(".magazine-form input[type='text'], .magazine-form input[type='email']").keyup(function(){
		var name = $(this).attr("name");
		
		if(name != undefined){
		  $("input[name='" + name + "']").val($(this).val());
		}
	});
	
	$(".magazine-form input[type='checkbox']").unbind("click");
	$(".magazine-form input[type='checkbox']").bind("click",function(e) {
		var name = $(this).attr("name");
		if(name != undefined){
			if($(this).is(":checked")){
				$("input[name='" + name + "']").prop('checked', true);
				
				if($(this).hasClass("form-magazine-address-chk")){
					$(".form-content-magazine-address").fadeIn();
				}else if($(this).hasClass("form-magazine-email-chk")){
					$(".form-content-magazine-email").fadeIn();
				}
			}else{
				$("input[name='" + name + "']").prop('checked', false);
				
				if($(this).hasClass("form-magazine-address-chk")){
					$(".form-content-magazine-address").fadeOut();
				}else if($(this).hasClass("form-magazine-email-chk")){
					$(".form-content-magazine-email").fadeOut();
				}
			}
		}
	});
}

module.exports = {
	init : init
}